import React, { MouseEventHandler } from "react"
import { ToothErrorIcon } from "../../../icons/ToothErrorIcon"
import { ButtonPrimary } from "../../atoms/button"
import { Heading2, TextRegular } from "../../atoms/text"
import styled from "styled-components"
import { theme } from "../../../theme"

export type ErrorNodeProps = {
  title: string
  description: string
  backgroundText?: string
  button?: ButtonErrorProps
}
export type ButtonErrorProps = {
  label: string
  action: MouseEventHandler<HTMLButtonElement>
}

export const ErrorNode = (props: ErrorNodeProps) => {
  const { title, description, button, backgroundText } = props
  return (
    <Root>
      {!!backgroundText && <BackgroundText>{backgroundText}</BackgroundText>}
      <ToothErrorIcon />
      <ErrorTitle>{title}</ErrorTitle>
      <DescriptionError>{description}</DescriptionError>

      {!!button && <ButtonPrimary onClick={button.action}>{button.label}</ButtonPrimary>}
    </Root>
  )
}

const BackgroundText = styled.div`
  font-weight: 700;
  font-size: 288px;
  line-height: 34px;
  display: flex;
  align-items: center;
  text-align: center;
  color: ${theme.color.white2};
`

const ErrorTitle = styled(Heading2)`
  margin-top: ${theme.spacing.m};
`

const DescriptionError = styled(TextRegular)`
  margin-top: ${theme.spacing.m};
  margin-bottom: ${theme.spacing.xl};
`
const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  justify-content: center;
  flex-grow: 1;
`
